<template>
  <div>
    <!-- Loading Personalizado -->
    <div v-if="showCustomLoading" class="loading-overlay">
      <div class="loading-container">
        <div class="loading-logo">
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 809.66 222.58"
            style="enable-background: new 0 0 809.66 222.58"
            xml:space="preserve"
          >
            <g>
              <polygon
                class="stm"
                points="124.91,0 230.19,0 177.55,51.37 124.91,102.74 72.26,51.37 19.62,0"
              />
              <g>
                <polygon
                  class="stm"
                  points="113.66,113.75 28.34,28.68 0,0 0,202.36 45.58,202.36 45.58,106.1 113.66,173.98"
                />
                <polygon
                  class="stm"
                  points="136.14,113.75 221.46,28.68 249.8,0 249.8,202.36 204.22,202.36 204.22,106.1 136.14,173.98"
                />
              </g>
              <path
                class="stu"
                d="M311.47,202.51h-8.45c-27.49,0-45.25-14.71-45.25-37.47v-55.45h20v55.45c0,15.58,15.82,17.91,25.25,17.91h8.45
              c9.43,0,25.25-2.33,25.25-17.91v-55.45h20v55.45C356.72,187.8,338.96,202.51,311.47,202.51z"
              />
              <path d="M370.72,110.58" />
              <polygon
                class="stl"
                points="386.45,182.24 386.45,109.53 366.45,109.53 366.45,202.24 444.08,202.24 444.08,182.24"
              />
              <polygon
                class="ste"
                points="692.98,129.17 692.98,109.53 611.77,109.53 611.77,111.05 611.77,129.17 611.77,147.33 611.77,166.96 
              611.77,202.09 689.51,202.09 689.51,182.45 631.8,182.45 631.8,166.96 692.98,166.96 692.98,147.33 631.8,147.33 631.8,129.17"
              />
              <polygon
                class="stt"
                points="506.57,109.68 425.36,109.68 425.36,129.68 458.38,129.68 458.38,202.09 478.38,202.09 478.38,129.68 
              506.57,129.68"
              />
              <path
                class="stp"
                d="M572.08,109.68h-39.96H512.6h-0.49v92.42h20v-23.21h39.96c19.08,0,34.6-15.52,34.6-34.6
              C606.68,125.2,591.16,109.68,572.08,109.68z M572.08,158.89h-39.96v-29.21h39.96c8.05,0,14.6,6.55,14.6,14.6
              C586.68,152.34,580.13,158.89,572.08,158.89z"
              />
              <polygon
                class="stx"
                points="809.66,109.98 786.1,109.98 752.27,144.29 718.45,109.98 694.89,109.98 740.49,156.24 694.89,202.51 
              718.45,202.51 752.27,168.19 786.1,202.51 809.66,202.51 764.05,156.24"
              />
            </g>
          </svg>
        </div>
        <div class="loading-text">
          <q-spinner-gears size="60px" color="primary" />
          <h2>Carregando relatório...</h2>
          <p>Por favor, aguarde</p>
        </div>
      </div>
    </div>

    <Pivot
      v-if="exibir"
      class="altura"
      ref="pivot"
      width="100%"
      v-bind:report="conexao"
      :beforetoolbarcreated="esconder"
      :beforedataloaded="beforeDataLoaded"
      :dataloaded="flexmonsterLoading"
      :licenseKey="licenseKey"
      v-bind:reportcomplete="onReportComplete"
      v-bind:reportchange="onReportComplete"
      toolbar
    >
    </Pivot>
    <!-- <div
      v-else
      class="row col-12 justify-center items-center"
      style="height: 70vh"
    >
      <LoadingLogo />
    </div> -->
    <save
      :relatorioSalvo="dadosRelatorioSalvo?.nome"
      :loading="loading"
      :abrir="salvar"
      @emitir="injectOptions"
      @salvarLocal="baixarRelatorioJson"
    />
  </div>
</template>

<script>
import { defineComponent, ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRoute } from "vue-router";

import Save from "../components/Salvar.vue";
import LinguagemPt from "../pt.json";
// import LoadingLogo from "../../../components/loading/LoadingLogo.vue";

export default defineComponent({
  name: "CompositionAPIDemo",
  components: {
    Save,
    // LoadingLogo,
  },
  emits: ["enviarRespostaEp", "flexmonsterLoading"],
  props: {
    link: {
      type: String,
      required: true,
      default: "",
    },

    url: {
      type: String,
      default: "",
    },

    urlEp: {
      type: String,
      default: "",
    },

    exibir: {
      type: Boolean,
      default: false,
    },

    relatorioCarregado: {
      type: Boolean,
      default: false,
    },

    gerarCsv: {
      type: Boolean,
      default: false,
    },

    dadosRelatorioSalvo: {
      type: Object,
    },

    slice: {
      type: Object,
      default: () => {},
    },

    grid: {
      type: String,
      default: "flat",
    },

    cnpjName: {
      type: String,
      default: "CNPJ",
    },
    filtros: {
      type: String,
      default: "",
    },
    types: {
      type: Object,
      default: () => {},
    },
    updateLink: {
      type: Number,
    },
    salvarType: {
      type: String,
    },
    showTotals: {
      type: String,
    },
    showGrandTotals: {
      type: String,
      default: "off",
    },
    formats: {
      type: Array,
      default: () => {},
    },
    exportName: {
      type: String,
      default: "flexmonster",
    },
    customLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const route = useRoute();

    let pivot = ref("");
    const pivotBase = ref(null);
    const salvar = ref(false);
    const loading = ref(false);
    const hasExpandedFirstRow = ref(0);
    const mappingFixed = ref(false);
    const dataCompletaSortOrder = ref([]);
    const gridSave = ref("");
    const store = useStore();
    const $q = useQuasar();
    const showCustomLoading = ref(false);

    const parseDateRangeFromUrl = (url) => {
      if (!url || typeof url !== "string") return null;

      try {
        const parsed = new URL(url);
        const start =
          parsed.searchParams.get("data_finalizacao_inicial") ||
          parsed.searchParams.get("data_inicial");
        const end =
          parsed.searchParams.get("data_finalizacao_final") ||
          parsed.searchParams.get("data_final");

        if (!start || !end) return null;
        return { start, end };
      } catch (error) {
        return null;
      }
    };

    const buildDayByDaySortOrder = (startIso, endIso) => {
      const start = startIso?.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      const end = endIso?.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!start || !end) return [];

      const startDate = new Date(
        Number(start[1]),
        Number(start[2]) - 1,
        Number(start[3])
      );
      const endDate = new Date(
        Number(end[1]),
        Number(end[2]) - 1,
        Number(end[3])
      );

      if (
        Number.isNaN(startDate.getTime()) ||
        Number.isNaN(endDate.getTime())
      ) {
        return [];
      }

      const order = [];
      const current = new Date(startDate);

      while (current <= endDate) {
        const dd = String(current.getDate()).padStart(2, "0");
        const mm = String(current.getMonth() + 1).padStart(2, "0");
        const yyyy = current.getFullYear();
        order.push(`${dd}/${mm}/${yyyy}`);
        current.setDate(current.getDate() + 1);
      }

      return order;
    };

    const formatDateToPtBr = (dateString) => {
      if (!dateString) return dateString;

      const cleanDate = dateString.toString().trim();

      const lowerValue = cleanDate.toLowerCase();
      if (
        lowerValue === "invalid date" ||
        lowerValue === "blank" ||
        lowerValue === "(blank)"
      ) {
        return "";
      }

      const dateWithoutTime = cleanDate.split(" ")[0];

      const dateRegexIso = /^(\d{4})-(\d{1,2})-(\d{1,2})$/;
      const matchIso = dateWithoutTime.match(dateRegexIso);
      if (matchIso) {
        const [, year, month, day] = matchIso;
        return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
      }

      const dateRegexIsoSlash = /^(\d{4})\/(\d{1,2})\/(\d{1,2})$/;
      const matchIsoSlash = dateWithoutTime.match(dateRegexIsoSlash);
      if (matchIsoSlash) {
        const [, year, month, day] = matchIsoSlash;
        return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
      }

      const dateRegexSlash = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
      const matchSlash = dateWithoutTime.match(dateRegexSlash);
      if (matchSlash) {
        const [, first, second, year] = matchSlash;
        const firstNum = parseInt(first);
        const secondNum = parseInt(second);

        if (firstNum > 12) {
          return `${first.padStart(2, "0")}/${second.padStart(2, "0")}/${year}`;
        }

        if (secondNum > 12) {
          return `${second.padStart(2, "0")}/${first.padStart(2, "0")}/${year}`;
        }

        return `${first.padStart(2, "0")}/${second.padStart(2, "0")}/${year}`;
      }

      return dateWithoutTime;
    };

    const isDate = (value) => {
      if (!value) return false;

      const cleanValue = value.toString().trim();

      const lowerValue = cleanValue.toLowerCase();
      if (
        lowerValue === "invalid date" ||
        lowerValue === "blank" ||
        lowerValue === "(blank)"
      ) {
        return false;
      }

      const dateWithoutTime = cleanValue.split(" ")[0];

      const dateRegexSlash = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
      if (dateRegexSlash.test(dateWithoutTime)) return true;

      const dateRegexIso = /^(\d{4})-(\d{1,2})-(\d{1,2})$/;
      if (dateRegexIso.test(dateWithoutTime)) return true;

      const dateRegexIsoSlash = /^(\d{4})\/(\d{1,2})\/(\d{1,2})$/;
      if (dateRegexIsoSlash.test(dateWithoutTime)) return true;

      return false;
    };

    onMounted(() => {
      store.commit("rel/DESATIVAR_LOADING_PERSONALIZADO");
      showCustomLoading.value = false;
    });

    watch(
      () => store.state.rel.loadingPersonalizado,
      (newValue) => {
        showCustomLoading.value = newValue;

        if (newValue === true) {
          setTimeout(() => {
            store.commit("rel/DESATIVAR_LOADING_PERSONALIZADO");
          }, 60000);
        }
      }
    );

    let conexao = ref({
      dataSource: {
        filename: props.link,
        mapping: props.types,
      },

      localization: LinguagemPt,

      options: {
        grid: {
          type: props.grid,
          showGrandTotals: props.showGrandTotals,
          showTotals: props.showTotals,
        },
        datePattern: "dd/MM/yyyy",
        dateTimePattern: "dd/MM/yyyy HH:mm:ss",
        configuratorActive: false,
        defaultDateType: "date string",
        allowBrowsersCache: true,
        useCustomizeApiForExport: true,
        excelExportAllData: true,
      },

      slice: props.slice,
      formats: props.formats,
    });

    const esconder = async (toolbar) => {
      pivotBase.value = pivot.value;

      pivot.value = toolbar;

      const instancia = pivotBase.value?.flexmonster || toolbar.flexmonster;
      aplicarPatchExportacao(instancia);

      let tabs = toolbar.getTabs();
      toolbar.getTabs = function () {
        tabs = tabs.filter(
          (tab) =>
            tab.id != "fm-tab-connect" &&
            tab.id != "fm-tab-save" &&
            tab.id != "fm-tab-open"
        );

        tabs[6].menu.push({
          id: "fm-tab-expand",
          title: "Expandir Tudo",
          handler: expandir,
        });

        tabs[6].menu.push({
          id: "fm-tab-colaps",
          title: "Fechar Tudo",
          handler: encolher,
        });

        if (
          props.relatorioCarregado == false ||
          props.relatorioCarregado == undefined
        ) {
          tabs.unshift({
            id: "fm-tab-newtab",
            title: "Salvar",
            handler: NomeArquivo,
            icon: this.icons.save,
          });
        }

        pivotBase.value.flexmonster.customizeCell((cell, data) => {
          if (data && data.label) {
            const label = data.label.toString().toLowerCase();
            if (
              label === "(blank)" ||
              label === "blank" ||
              label === "invalid date"
            ) {
              cell.text = "";
              return;
            }
          }

          if (cell && cell.text) {
            const cellText = cell.text.toString().toLowerCase();
            if (
              cellText === "(blank)" ||
              cellText === "blank" ||
              cellText === "invalid date"
            ) {
              cell.text = "";
              return;
            }
          }

          if (
            data &&
            data.hierarchy &&
            data.hierarchy.uniqueName === props.cnpjName &&
            data.type === "value"
          ) {
            const formatCNPJ = (cnpj) => {
              return cnpj
                .toString()
                .padStart(14, "0") // garante 14 dígitos
                .replace(
                  /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
                  "$1.$2.$3/$4-$5"
                );
            };

            if (data.label && /^\d+$/.test(data.label)) {
              cell.text = formatCNPJ(data.label);
            }
          }

          if (data.label && isDate(data.label)) {
            cell.text = formatDateToPtBr(data.label);
          }
        });

        // Adicionando handler à tab fm-tab-export
        const exportTab = tabs.find((tab) => tab.id === "fm-tab-export");

        if (exportTab) {
          exportTab.menu[2].handler = async () => {
            flexmonsterLoading(true, pivotBase.value, "csv");
          };
          exportTab.menu[3].handler = async () => {
            flexmonsterLoading(true, pivotBase.value, "excel");
          };
        }

        return tabs;
      };
    };

    const NomeArquivo = async () => {
      salvar.value = !salvar.value;
    };

    const injectOptions = async (name, tipoAcao) => {
      setTimeout(async () => {
        const report = await pivot.value.flexmonster.getReport();
        const grid = await pivot.value.flexmonster.getOptions();
        const filtros = await pivot.value.flexmonster.getReportFilters();

        let columns = report?.slice?.columns;
        let values = report?.slice?.measures;
        let rowsFilter = report?.slice?.rows;
        let flatOrder = report?.slice?.flatOrder || [];
        let formats = report?.formats || [];

        gridSave.value = {
          layout: grid?.grid?.type,
          showTotals: grid?.grid?.showTotals,
          showGrandTotals: grid?.grid?.showGrandTotals,
          columns: columns,
          rows: rowsFilter,
          filtros: filtros,
          values: values,
          flatOrder: flatOrder,
          formats: formats,
          options: { useCustomizeApiForExport: true, excelExportAllData: true },
        };

        if (tipoAcao == "editar") {
          editar();
          return;
        }
        save(name);
      }, 1000);
    };

    const save = async (nome) => {
      if (nome === "" || nome === undefined) {
        $q.notify({
          message: "Erro a o salvar arquivo, o nome não pode ser vazio",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      loading.value = true;
      try {
        await store.dispatch("rel/salvarRelatorio", {
          nome: nome,
          url: props.url,
          tipoRelatorio: props.salvarType,
          filtros: props.filtros,
          template: JSON.stringify(gridSave.value),
        });
        $q.notify({
          message: "Relatorio salvo com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        loading.value = false;
      } catch (error) {
        $q.notify({
          message: "Erro a o salvar relatorio",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
      loading.value = false;
    };

    const editar = async () => {
      loading.value = true;
      try {
        await store.dispatch("rel/editarRelatorio", {
          id: props.dadosRelatorioSalvo?.id,
          url: props.url,
          filtros: props.filtros,
          template: JSON.stringify(gridSave.value),
        });
        $q.notify({
          message: "Relatorio editado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        loading.value = false;
      } catch (error) {
        $q.notify({
          message: "Erro a o editar relatorio",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
      loading.value = false;
    };

    const hasValidMapping = (mapping) => {
      return (
        mapping &&
        typeof mapping === "object" &&
        !Array.isArray(mapping) &&
        Object.keys(mapping).length > 0
      );
    };

    watch(
      () => props.updateLink,
      (newValue, oldValue) => {
        if (newValue !== oldValue && newValue > 0) {
          if (!showCustomLoading.value) {
            showCustomLoading.value = true;
          }

          setTimeout(() => {
            showCustomLoading.value = false;
          }, 2000);
        }

        // Reset mapping flag para re-aplicar no próximo reportComplete
        mappingFixed.value = false;

        setTimeout(() => {
          pivot.value?.flexmonster?.updateData({
            type: "csv",
            filename: props.link,
            mapping: hasValidMapping(props.types) ? props.types : undefined,
          });
        }, 800);
      }
    );

    watch(
      () => props.link,
      () => {
        conexao.value.dataSource.filename = props.link;
        conexao.value.dataSource.mapping = hasValidMapping(props.types)
          ? props.types
          : undefined;
        mappingFixed.value = false;
        conexao.value.options.grid.type =
          props.dadosRelatorioSalvo?.layout ||
          props.grid ||
          props.dadosRelatorioSalvo?.template?.layout;
        // O Flexmonster usa o `slice` no nível raiz do report — garantir que seja passado corretamente
        conexao.value.slice = props.slice;
        conexao.value.formats = props.formats;
        conexao.value.mapping = props.types;
        conexao.value.options.grid.showTotals = props.showTotals;
        conexao.value.options.grid.showGrandTotals = props.showGrandTotals;
      }
    );

    watch(
      () => props.formats,
      (newFormats) => {
        conexao.value.formats = newFormats;

        if (pivot.value && pivot.value.flexmonster) {
          const report = pivot.value.flexmonster.getReport();
          if (report) {
            report.formats = newFormats;
            pivot.value.flexmonster.setReport(report);
          }
        }
      },
      { deep: true }
    );

    watch(
      () => props.customLoading,
      (newValue) => {
        showCustomLoading.value = newValue;
      }
    );

    const gerarLinkCsv = async () => {
      const api = await store.dispatch("autenticacao/criarApiFlexmonster");
      const response = await api.get(props.dadosRelatorioSalvo?.url);
      emit("enviarRespostaEp", response.data);
    };

    const baixarRelatorioJson = async (nomeArquivo = null) => {
      loading.value = true;
      let configuracoesRelatorio = {};

      let grid = await pivot.value.flexmonster.getOptions();
      let report = await pivot.value.flexmonster.getReport();
      let columns = report?.slice?.columns;
      let filtros = await pivot.value.flexmonster.getReportFilters();
      let values = report?.slice?.measures;
      let rows = report?.slice?.rows;
      let flatOrder = report?.slice?.flatOrder || [];
      let formats = report?.formats || props.formats || [];
      configuracoesRelatorio = {
        rotaNome: route.name,
        url: props.url,
        filtrosTela: props.filtros,
        layout: grid?.grid?.type,
        showTotals: grid?.grid?.showTotals,
        showGrandTotals: grid?.grid?.showGrandTotals,
        columns: columns,
        rows: rows,
        filtros: filtros,
        values: values,
        flatOrder: flatOrder,
        slice: report?.slice,
        formats: formats,
        options: {
          useCustomizeApiForExport: true,
          excelExportAllData: false,
        },
      };

      let json = JSON.stringify(configuracoesRelatorio, null, 2);

      let element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/json;charset=utf-8," + encodeURIComponent(json)
      );
      const nomeBase =
        nomeArquivo ||
        props.dadosRelatorioSalvo?.nome ||
        route.name ||
        "relatorio";
      element.setAttribute("download", `relatorio-${nomeBase}`);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
      loading.value = false;
    };

    const onReportComplete = async () => {
      if (!pivotBase.value || !pivotBase.value.flexmonster) return;

      const pivotValue = pivotBase.value.flexmonster;
      const report = pivotValue.getReport();

      //  Se o slice não existe ou está vazio, ignore este ciclo
      if (
        !report ||
        !report.slice ||
        (!report.slice.columns && !report.slice.rows)
      ) {
        return;
      }

      // Forçar todos os campos como string se mapping não foi aplicado ainda
      if (!mappingFixed.value) {
        const report = pivotValue.getReport();
        if (report && report.dataSource) {
          // Pegar todos os campos descobertos pelo Flexmonster e forçar como string
          const allHierarchies = pivotValue.getAllHierarchies() || [];
          const allMeasures = pivotValue.getAllMeasures() || [];
          const stringMapping = {};

          allHierarchies.forEach((h) => {
            if (h.uniqueName) {
              stringMapping[h.uniqueName] = { type: "string" };
            }
          });
          allMeasures.forEach((m) => {
            if (m.uniqueName) {
              stringMapping[m.uniqueName] = { type: "string" };
            }
          });

          // Sobrescrever com os types específicos definidos no relatório
          if (hasValidMapping(props.types)) {
            Object.assign(stringMapping, props.types);
          }

          if (Object.keys(stringMapping).length > 0) {
            mappingFixed.value = true;
            report.dataSource.mapping = stringMapping;
            pivotValue.setReport(report);
            return;
          }
        }
        mappingFixed.value = true;
      }

      if (hasExpandedFirstRow.value > 3) return;

      const columns = report?.slice?.rows || [];
      const reportColumns = report?.slice?.columns || [];

      if (!dataCompletaSortOrder.value.length) {
        const range = parseDateRangeFromUrl(props.url);
        if (range) {
          dataCompletaSortOrder.value = buildDayByDaySortOrder(
            range.start,
            range.end
          );
        }
      }

      if (dataCompletaSortOrder.value.length) {
        const dataCompletaColumnIndex = reportColumns.findIndex(
          (col) => col.uniqueName === "DataCompleta"
        );

        if (dataCompletaColumnIndex !== -1) {
          reportColumns[dataCompletaColumnIndex].sort = "asc";
          reportColumns[dataCompletaColumnIndex].sortOrder =
            dataCompletaSortOrder.value;
          reportColumns[dataCompletaColumnIndex].filter = {
            // O Flexmonster exige o formato "NomeDaColuna.[Valor]" para filtrar
            members: dataCompletaSortOrder.value.map(
              (data) => `DataCompleta.[${data}]`
            ),
          };
        }

        const dataCompletaRowIndex = columns.findIndex(
          (col) => col.uniqueName === "DataCompleta"
        );

        if (dataCompletaRowIndex !== -1) {
          columns[dataCompletaRowIndex].sort = "asc";
          columns[dataCompletaRowIndex].sortOrder = dataCompletaSortOrder.value;
        }

        if (dataCompletaColumnIndex !== -1 || dataCompletaRowIndex !== -1) {
          pivotValue.setReport({
            ...report,
            slice: {
              ...report.slice,
              columns: reportColumns,
              rows: columns,
            },
          });
        }
      }

      const mesesOrdenados = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ];

      const mesColumnIndex = reportColumns.findIndex(
        (col) => col.uniqueName === "Mes"
      );
      if (mesColumnIndex !== -1) {
        reportColumns[mesColumnIndex].sort = "asc";
        reportColumns[mesColumnIndex].sortOrder = mesesOrdenados;

        pivotValue.setReport({
          ...report,
          slice: {
            ...report.slice,
            columns: reportColumns,
          },
        });
      }

      const mesRowIndex = columns.findIndex((col) => col.uniqueName === "Mes");
      if (mesRowIndex !== -1) {
        columns[mesRowIndex].sort = "asc";
        columns[mesRowIndex].sortOrder = mesesOrdenados;

        pivotValue.setReport({
          ...report,
          slice: {
            ...report.slice,
            rows: columns,
          },
        });
      }

      if (columns.length > 0) {
        const firstColumnField = columns[0].uniqueName;
        try {
          await pivotValue.expandData(firstColumnField);
          hasExpandedFirstRow.value++;
        } catch (error) {
          console.warn("Nenhuma coluna encontrada no slice.");
        }
      }
    };

    watch(
      () => props.gerarCsv,
      () => {
        if (!props.gerarCsv) {
          return;
        }
        gerarLinkCsv();
      }
    );

    watch(
      () => props.url,
      () => {
        dataCompletaSortOrder.value = [];
      }
    );

    const expandir = async () => {
      await pivot.value.pivot.expandAllData();
    };

    const encolher = async () => {
      await pivot.value.pivot.collapseAllData();
    };

    const flexmonsterLoading = async (
      exportt = false,
      pivotBase,
      exportType = "excel"
    ) => {
      showCustomLoading.value = false;

      if (exportt) {
        pivotBase.flexmonster.customizeCell((cell, data) => {
          // tratar valores "blank" e "invalid_date"
          if (data && data.label) {
            const label = data.label.toString().toLowerCase();
            if (
              label === "(blank)" ||
              label === "blank" ||
              label === "invalid date"
            ) {
              cell.text = "";
              return;
            }
          }

          if (cell && cell.text) {
            const cellText = cell.text.toString().toLowerCase();
            if (
              cellText === "(blank)" ||
              cellText === "blank" ||
              cellText === "invalid date" ||
              cellText.includes("invalid")
            ) {
              cell.text = "";
              return;
            }
          }

          if (isDate(data.label)) {
            cell.text = formatDateToPtBr(data.label);
          }

          if (data.measure && data.type !== "header" && exportt == false) {
            cell.text = data.label;
          }
        });
        const dataAtual = new Date();
        const ano = dataAtual.getFullYear();
        const mes = dataAtual.getMonth() + 1;
        const dia = dataAtual.getDate();
        pivotBase.flexmonster.exportTo(
          exportType,
          {
            filename: `Relatorio_de_${props.exportName}_${dia}_${mes}_${ano}`,
            useFormatter: true,
            useCustomizeApiForExport: true,
            exportAllData: true,
            excelExportAllData: true,
          },
          function () {
            emit("flexmonsterLoading", false);
          }
        );
        return;
      }

      if (pivot.value && pivot.value.flexmonster) {
        pivot.value.flexmonster.customizeCell((cell, data) => {
          // tratar valores "blank" e "invalid_date"
          if (data && data.label) {
            const label = data.label.toString().toLowerCase();
            if (
              label === "(blank)" ||
              label === "blank" ||
              label === "invalid date"
            ) {
              cell.text = "";
              return;
            }
          }

          if (cell && cell.text) {
            const cellText = cell.text.toString().toLowerCase();
            if (
              cellText === "(blank)" ||
              cellText === "blank" ||
              cellText === "invalid date" ||
              cellText.includes("invalid")
            ) {
              cell.text = "";
              return;
            }
          }

          if (
            data &&
            data.hierarchy &&
            data.hierarchy.uniqueName === props.cnpjName &&
            data.type === "value"
          ) {
            const formatCNPJ = (cnpj) => {
              return cnpj
                .toString()
                .padStart(14, "0")
                .replace(
                  /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
                  "$1.$2.$3/$4-$5"
                );
            };

            if (data.label && /^\d+$/.test(data.label)) {
              cell.text = formatCNPJ(data.label);
            }
          }

          if (isDate(data.label)) {
            cell.text = formatDateToPtBr(data.label);
          }

          if (data.measure && data.type !== "header" && exportt == false) {
            cell.text = `<span class="tooltip" title="${data.label}">${data.label}</span>`;
          }
        });
      }

      emit("flexmonsterLoading", false);
    };

    const beforeDataLoaded = (data) => {
      if (!data || !data.data) return;

      data.data.forEach((row, index) => {
        Object.keys(row).forEach((key) => {
          const value = row[key];

          if (value && typeof value === "string") {
            const lowerValue = value.toLowerCase();

            if (
              lowerValue === "invalid date" ||
              lowerValue === "blank" ||
              lowerValue === "(blank)"
            ) {
              row[key] = "";
              return;
            }

            if (isDate(value)) {
              const dataFormatada = formatDateToPtBr(value);
              if (index < 5 && (key === "CriadaEm" || key === "DataCompleta"))
                row[key] = dataFormatada;
            }
          }
        });
      });
    };

    const aplicarPatchExportacao = (instanciaFlex) => {
      if (!instanciaFlex || instanciaFlex.funcaoExportarOriginal) return;

      instanciaFlex.funcaoExportarOriginal = instanciaFlex.exportTo;
      instanciaFlex.exportTo = function (formato, opcoes = {}, callback) {
        if (formato === "csv") {
          opcoes.fieldSeparator = ";";
        }
        if (formato === "excel" || formato === "xlsx") {
          opcoes.useFormatter = true;
          opcoes.useCustomizeCellForData = true;
          opcoes.excelExportAllData = true;
          opcoes.exportAllData = true;
        }
        instanciaFlex.funcaoExportarOriginal.call(
          this,
          formato,
          opcoes,
          callback
        );
      };
    };

    return {
      pivot,
      esconder,
      conexao,
      save,
      salvar,
      NomeArquivo,
      injectOptions,
      loading,
      licenseKey: process.env.VUE_APP_FLEXMONSTER_TOKEN,
      expandir,
      encolher,
      flexmonsterLoading,
      editar,
      baixarRelatorioJson,
      hasExpandedFirstRow,
      onReportComplete,
      showCustomLoading,
      beforeDataLoaded,
    };
  },
});
</script>

<style scoped>
.altura {
  height: 80vh !important;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
}

.loading-logo {
  width: 16rem;
  height: 8rem;
}

.loading-logo svg {
  width: 100%;
  height: 100%;
}

.loading-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  color: #21324a;
}

.loading-gears {
  animation: rotate 2s linear infinite;
}

.loading-gears svg {
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.loading-text h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: bold;
  color: #21324a;
}

.loading-text p {
  margin: 0;
  font-size: 1rem;
  color: #666;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.stm {
  fill: #5db8c9;
  animation: animacaoM 1s forwards infinite;
}

.stu {
  fill: #5db8c9;
  animation: animacaoU 1s forwards infinite;
}

.stl {
  fill: #5db8c9;
  animation: animacaoL 1s forwards infinite;
}

.stt {
  fill: #5db8c9;
  animation: animacaoT 1s forwards infinite;
}

.stp {
  fill: #5db8c9;
  animation: animacaoP 1s forwards infinite;
}

.ste {
  fill: #5db8c9;
  animation: animacaoE 1s forwards infinite;
}

.stx {
  fill: #5db8c9;
  animation: animacaoX 1s forwards infinite;
}

@keyframes animacaoM {
  0% {
    fill: gray;
  }
  30% {
    fill: #4fa6b8;
  }
  100% {
    fill: #4fa6b8;
  }
}

@keyframes animacaoU {
  0% {
    fill: gray;
  }
  40% {
    fill: #4fa6b8;
  }
  100% {
    fill: #4fa6b8;
  }
}

@keyframes animacaoL {
  0% {
    fill: gray;
  }
  60% {
    fill: #4fa6b8;
  }
  100% {
    fill: #4fa6b8;
  }
}

@keyframes animacaoT {
  0% {
    fill: gray;
  }
  70% {
    fill: #4fa6b8;
  }
  100% {
    fill: #4fa6b8;
  }
}

@keyframes animacaoP {
  0% {
    fill: gray;
  }
  80% {
    fill: #4fa6b8;
  }
  100% {
    fill: #4fa6b8;
  }
}

@keyframes animacaoE {
  0% {
    fill: gray;
  }
  90% {
    fill: #4fa6b8;
  }
  100% {
    fill: #4fa6b8;
  }
}

@keyframes animacaoX {
  0% {
    fill: gray;
  }
  100% {
    fill: #4fa6b8;
  }
}
</style>

<style>
.tooltip {
  position: relative;
  z-index: 100 !important;
  display: inline-block;
}
.fm-grid-column {
  max-width: 2000px;
}
</style>
